import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map } from 'rxjs';

import { TableConfig } from '../../models/table.model';

@Injectable()
export class TableSearchHighlightService {
  private readonly defaultSearchParam = 'k';
  private searchParam = this.defaultSearchParam;

  readonly searchTerm$ = inject(ActivatedRoute).queryParams.pipe(
    map(params => params?.[this.searchParam]),
  );

  listen(config: TableConfig<unknown>['highlightOnSearch'] | undefined): void {
    this.searchParam = config?.overrideSearchParam || this.defaultSearchParam;
  }
}
